var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTheLovers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 359.83 499.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke-width: 4px;\n      }\n\n      .cls-1, .cls-2 {\n        stroke: #fff;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-2 {\n        fill: #fff200;\n        stroke-width: 2px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 78.13,
    y1: 26.64,
    x2: 176.12,
    y2: 52.71
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 191.73,
    y1: 52.71,
    x2: 268.32,
    y2: 26.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 73.31,
    y1: 20,
    x2: 183.93,
    y2: 267.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 273.14,
    y1: 20,
    x2: 183.93,
    y2: 267.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 335.25,
    y1: 266.71,
    x2: 183.93,
    y2: 267.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 21.41,
    y1: 267.41,
    x2: 183.93,
    y2: 267.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 142.57,
    y1: 475.58,
    x2: 183.93,
    y2: 267.24
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "183.93 76.73 179.1 61.89 163.5 61.89 176.12 52.71 171.3 37.87 183.93 47.04 196.55 37.87 191.73 52.71 204.36 61.89 188.75 61.89 183.93 76.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "73.31 41.48 68.48 26.64 52.88 26.64 65.5 17.46 60.68 2.62 73.31 11.79 85.93 2.62 81.11 17.46 93.74 26.64 78.13 26.64 73.31 41.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "273.14 41.48 268.32 26.64 252.71 26.64 265.34 17.46 260.52 2.62 273.14 11.79 285.77 2.62 280.95 17.46 293.57 26.64 277.97 26.64 273.14 41.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "188.39 288.26 180.59 274.74 165.32 277.98 175.77 266.39 167.96 252.87 182.22 259.22 192.66 247.62 191.03 263.14 205.29 269.49 190.02 272.73 188.39 288.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "123.97 486.32 134.41 474.72 126.61 461.2 140.87 467.55 151.31 455.95 149.68 471.47 163.94 477.82 148.67 481.07 147.04 496.59 139.24 483.07 123.97 486.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "2.8 278.15 13.25 266.55 5.44 253.03 19.7 259.38 30.14 247.78 28.51 263.3 42.77 269.65 27.5 272.9 25.87 288.42 18.07 274.9 2.8 278.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "316.65 277.45 327.09 265.86 319.29 252.34 333.55 258.69 343.99 247.09 342.36 262.61 356.62 268.96 341.35 272.2 339.72 287.73 331.91 274.21 316.65 277.45"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTheLovers);
export default __webpack_public_path__ + "static/media/TheLovers.7ed94d190243267c71b630c3942c0bc0.svg";
export { ForwardRef as ReactComponent };